import { useParams } from 'react-router-dom';

interface QueryData {
  url: string;
  periodId: string;
}

export function useDocumentsUploadUrlParams(): QueryData {
  const { periodId } = useParams<{ periodId: string }>();
  if (!periodId) {
    throw new Error(`Cannot load the page with invalid enrollment period: ${periodId}`);
  }

  return {
    url: `${periodId}`,
    periodId,
  };
}
